module.exports = __webpack_public_path__ + "img/madnessBanner_900.e2309edd.png";